import {
    Directive,
    Input,
    OnChanges,
    OnInit,
    inject
} from "@angular/core";
import { RadiobuttonGroupComponent } from "./radiobuttongroup.component";

@Directive({ selector: "rask-radiobutton-group[raskYesNoOptions]" })
export class YesNoOptionsDirective implements OnChanges, OnInit {
    @Input() invert = false;
    @Input() no = "Nej";
    @Input() yes = "Ja";

    private readonly radioButtonGroupComponent = inject(RadiobuttonGroupComponent);

    ngOnChanges(): void {
        this.setButtons();
    }

    ngOnInit(): void {
        this.setButtons();
    }

    private setButtons() {
        const buttons = [
            { key: true,
                value: this.yes },
            { key: false,
                value: this.no }
        ];
        if(this.invert) {
            buttons.reverse();
        }

        this.radioButtonGroupComponent.buttons = buttons;
    }
}
